var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var getUpdatedMappedMenu = function (_a) {
    var loadedItems = _a.loadedItems, mappedMenu = _a.mappedMenu;
    return mappedMenu.map(function (mappedMenuItem) {
        var loadedItem = loadedItems.find(function (loadedItem) { return loadedItem.name === mappedMenuItem.name; });
        if (loadedItem) {
            return __assign(__assign({}, mappedMenuItem), { routeName: loadedItem.routeName, loaded: loadedItem.loaded, url: loadedItem.path, config: loadedItem.config });
        }
        if (mappedMenuItem.nextLevelItems) {
            var updatedNextLevelItems = getUpdatedMappedMenu({
                loadedItems: loadedItems,
                mappedMenu: mappedMenuItem.nextLevelItems,
            });
            return __assign(__assign({}, mappedMenuItem), { nextLevelItems: updatedNextLevelItems });
        }
        return mappedMenuItem;
    });
};
